export const addGallery = (list) => {
  const galleryList = document.querySelector('[data-project-gallery-list]');

  if (galleryList)
    galleryList.appendChild(list)
}